import { includes } from 'lodash';
import Constants, { MdmVendorStates } from 'client/util/Constants';

const {
  filterNames,
} = Constants;

const {
  internal,
  external,
  none,
} = MdmVendorStates;

export function getFilters(fltrs, defaultFilters) {
  let filters = fltrs;
  // When another "state" filter is applied, UNINSTALL_SUCCESS is
  // redundant so we should exclude it from the request.
  const stateFilters = fltrs.filter(fltr => fltr.name === 'state' && fltr.value !== '');
  if (!stateFilters.length) filters = fltrs.concat(defaultFilters);
  return filters;
}

export function getSearchField(searchTerm, valueMap) {
  const searchObj = {
    field: undefined,
    value: undefined,
  };

  if (!includes(searchTerm, ':')) return searchObj;

  const searchTermArray = searchTerm.split(':');

  if (valueMap[searchTermArray[0]]) {
    searchObj.field = valueMap[searchTermArray[0]];
    // eslint-disable-next-line prefer-destructuring
    searchObj.value = searchTermArray[1].trim();
  }
  return searchObj;
}

export function setFilterTerm(params, filters = []) {
  return filters
    .reduce((acc, filter) => {
      const {
        customType, // Needed for V1 filters on systems
        field,
        name,
        logicalOperator,
        operator,
        value,
      } = filter;
      if (value !== '') {
        if (customType) {
        /* V1 of the api does not support filters unless they are formatted correctly
        * we have to add a custom format due to the item table being so connected to the
        * fetch Collection. With the custom filter we push the entire filter through and modify it
        * in the SystemApi params. This is only available with one type of custom filter, additional
        * filters are not allowed.
        */
          acc.push(filter);
        } else if (name === filterNames.mdmVendor && value === none) {
          acc.push(`${name}:$ne:${internal}`);
          acc.push(`${name}:$ne:${external}`);
        } else
        if (field) {
          acc.push(`${field}:${operator}:${value}`);
        } else if (logicalOperator) {
          acc.push({ filterValue: `${name}:${operator}:${value}`, logicalOperator });
        } else {
          acc.push(`${name}:${operator}:${value}`);
        }
      }
      return acc;
    }, []);
}

export function setSearchTerm(params, searchTerm, valueMap) {
  const searchObj = getSearchField(searchTerm, valueMap);
  const uniqueIdentifiers = [
    '_id',
    'mdm.internal.deviceId',
  ];

  if (!searchTerm) {
    // eslint-disable-next-line no-param-reassign
    delete params.search;
    return;
  }

  if (!searchObj.field) {
    // eslint-disable-next-line no-param-reassign
    params.search.searchTerm = searchTerm;
    return;
  }

  if (uniqueIdentifiers.includes(searchObj.field) && searchObj.value !== '') {
    params.filter.push(`${searchObj.field}:eq:${searchObj.value}`);
    // eslint-disable-next-line no-param-reassign
    delete params.search;
    return;
  }

  // eslint-disable-next-line
  params.search.fields = [ searchObj.field ];
  // eslint-disable-next-line
  params.search.searchTerm = searchObj.value;
}
